module.exports = __webpack_public_path__ + "img/je.62c6f6a0.svg";